import { axiosFactory, errorHandler, currentPage } from '@/configs/axios'

export const addFine = {
  api: (payload) => {
    return axiosFactory()
      .auth.post('fines/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getFineTypes = {
  api: () => {
    return axiosFactory()
      .auth.get(`fines/types/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getFines = {
  api: () => {
    return axiosFactory()
      .auth.get(`fines/`)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const getAFine = {
  api: (payload) => {
    return axiosFactory()
      .auth.get('fines/' + payload + '/')
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const editFine = {
  api: (payload) => {
    return axiosFactory()
      .auth.put('fines/' + payload.id + '/', payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}

export const removeFine = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete('fines/' + payload + '/')
      .then((res) => {
        return true
      })
      .catch((error) => {
        errorHandler(error)
      })
  },
}
